import {NgModel} from './ngModel';

export const Degree = NgModel.extend({
    _name: 'Degree',
});
